function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Nav, Text, SearchBox, ScreenWidthMinXLarge, Stack } from '@fluentui/react';
import { urlPush } from '@shared/routerHistory';
import SpzaComponent from '@shared/components/spzaComponent';
import { FilterPane as SharedFilterPane } from '@shared/components/filterPane';
import { InternalLink } from '@shared/components/internalLink';
import { getCategoryListByProductId } from '@shared/utils/datamappingHelpers';
import { Constants } from '@shared/utils/constants';
import { getWindow } from '@shared/services/window';
import { shouldShowSubFilter, sortFilters, serviceOffersSupportedCountriesMap, sort, getResetFiltersHref } from '@shared/utils/filterHelpers';
import { serviceOffersSupportedCAStates, serviceOffersSupportedUSStates } from '@shared/utils/serviceOffersSupportedStatesCodes';
import { FilterLink } from '@appsource/components/filterLink';
import { dataMapToArray } from '@shared/utils/dataMappingUtils';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
import { getFilterLink } from '@shared/utils/filterUtils';
import { useTelemetry } from '@shared/hooks/useTelemetry';
import { getNpsModule } from '@appsource/utils/nps';
import { logger } from '@src/logger';
import { BusinessTelemetry } from '@shared/utils/businessConstants';
import { listOfUrlKeysToExcludeInAppsource } from '@shared/oneTaxonomy';
import { ExternalLink } from '@shared/components/externalLink';
import { getProductByUrlKey } from '@shared/utils/appUtils';
import { isOneTaxonomyEnabled } from '@shared/oneTaxonomy/utils';
import { filterHideList, newlyAddedL1Categories, newlyAddedL2Categories } from '@shared/oneTaxonomy/constants';
import { isEmptyObject } from '@shared/utils/objectUtils';
const CATEGORIES_L1_EXCLUSION_LIST = [
    ...listOfUrlKeysToExcludeInAppsource,
    ...newlyAddedL1Categories
];
const CATEGORIES_L2_EXCLUSION_LIST = [
    ...filterHideList,
    ...newlyAddedL2Categories
];
// eslint-disable-next-line react-hooks/rules-of-hooks
const [{ pageAction }] = useTelemetry();
const rootGroupName = 'FilterType_Root';
const countryGroupName = 'FilterType_Countries';
const regionGroupName = 'FilterType_States';
export class FilterPane extends SpzaComponent {
    onMount() {
        this.telemetryComponentDidMount();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.setState({
            hasInit: true
        });
    }
    componentDidUpdate(prevProps) {
        if (!this.state.hasInit) {
            this.onMount();
        }
        if (this.props.dataMap !== prevProps.dataMap) {
            const filtersMap = this.getFiltersMap();
            const filtersExpandedState = this.computeFilterExpandedState(filtersMap);
            this.setState((prevState)=>{
                return {
                    filtersMap,
                    filtersExpandedState: _object_spread({}, prevState.filtersExpandedState, filtersExpandedState)
                };
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    telemetryComponentDidMount() {
        var _getWindow_performance, _getWindow;
        const window1 = getWindow();
        const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
        if (window1) {
            window1.loadTimeGalleryFilters = performance.now() - (requestStart - navigationStart);
        }
    }
    getCountryKey(countryCode) {
        return `COUNTRY_${countryCode}`;
    }
    getRegionKey(regionCode) {
        return `REGION_${regionCode}`;
    }
    generateKey({ FilterGroup, FilterID, UrlKey }) {
        return `${FilterGroup}_${FilterID}_${UrlKey}`;
    }
    getFiltersMap() {
        const dataMapArray = dataMapToArray(this.props.dataMap);
        const dataMapFilters = dataMapArray.reduce((dataMapFilters, dataValues)=>_object_spread_props(_object_spread({}, dataMapFilters), {
                [this.generateKey(dataValues)]: {
                    isChild: dataValues.IsChildFilter,
                    isActive: dataValues.isActive,
                    localizedName: dataValues.Title,
                    tooltip: dataValues.Tooltip,
                    group: dataValues.UrlGroup
                }
            }), {});
        const countriesFilters = Object.keys(this.props.countriesList).reduce((dataMapFilters, countryCode)=>_object_spread_props(_object_spread({}, dataMapFilters), {
                [this.getCountryKey(countryCode)]: {
                    isChild: true,
                    isActive: countryCode === this.props.countryCode
                }
            }), {});
        const regionsFilters = (this.getSelectedCountryRegions() || []).reduce((dataMapFilters, region)=>_object_spread_props(_object_spread({}, dataMapFilters), {
                [this.getRegionKey(region.code)]: {
                    isChild: true,
                    isActive: region.code === this.props.regionCode
                }
            }), {});
        return _object_spread({}, dataMapFilters, countriesFilters, regionsFilters);
    }
    computeFilterExpandedState(filtersMap) {
        return Object.keys(filtersMap).reduce((expandedFilters, key)=>{
            if (filtersMap[`${key}`].isActive) {
                expandedFilters[`${key}`] = true;
                const group = filtersMap[`${key}`].group;
                if (group) {
                    expandedFilters[`${group}`] = true;
                }
            }
            return expandedFilters;
        }, {});
    }
    getCurrentProduct(query) {
        if (query && typeof query.product === 'string') {
            const products = query.product.split(';');
            if (products && products.length > 0) {
                const product = products[0].trim();
                const productFilter = getProductByUrlKey({
                    urlKey: product
                });
                if (productFilter) {
                    const productBitMask = {
                        [productFilter.FilterGroup]: productFilter.FilterID
                    };
                    return productBitMask;
                }
            }
        }
    }
    parseFiltersMapToFilters(filtersMap, keys) {
        return this.parseFilters((keys || Object.keys(filtersMap)).map((filterKey)=>filtersMap[`${filterKey}`]));
    }
    parseFilters(filters) {
        const excludeList = this.props.isConverged ? listOfUrlKeysToExcludeInAppsource.filter((item)=>item !== 'azure') : CATEGORIES_L1_EXCLUSION_LIST;
        return filters.filter((filter)=>filter && !excludeList.includes(filter.UrlKey)).sort((filterA, filterB)=>sortFilters(filterA, filterB));
    }
    getCategoryList() {
        const currentProduct = this.getCurrentProduct(this.props.query);
        if (currentProduct) {
            const dynamicCategories = getCategoryListByProductId(currentProduct, this.props.dataMap);
            if (dynamicCategories) {
                return dynamicCategories;
            }
        }
        return this.props.dataMap.categories.default;
    }
    filterToLink(filter, links, parent) {
        const key = this.generateKey(filter);
        return {
            name: filter.LocKey || filter.Title,
            key,
            url: getFilterLink(this.context, this.props.entityType, filter, parent),
            isExpanded: !!this.state.filtersExpandedState[`${key}`],
            links
        };
    }
    groupToLink(name, key, links, tooltip = '') {
        return {
            name,
            key,
            url: '',
            isExpanded: !!this.state.filtersExpandedState[`${key}`],
            links,
            tooltip
        };
    }
    getFilterChildrenItems(filter) {
        if (!(filter && filter.SubCategoryDataMapping)) {
            return [];
        }
        const children = this.parseFiltersMapToFilters(filter.SubCategoryDataMapping);
        const filteredChildren = children.filter((categoryChild)=>shouldShowSubFilter(categoryChild));
        const filteredConvergedChildren = this.props.isConverged ? filteredChildren : filteredChildren.filter((categoryChild)=>!categoryChild.BackendKey.some((key)=>{
                // TODO: Remove after ai-apps-and-agents launch
                if (filter.UrlKey === 'ai-plus-machine-learning' && categoryChild.UrlKey === 'bot-service') {
                    return true;
                }
                return CATEGORIES_L2_EXCLUSION_LIST.includes(key);
            }));
        return filteredConvergedChildren.map((filterChild)=>this.filterToLink(filterChild, this.getFilterChildrenItems(filterChild), filter));
    }
    getProductChildrenItems(product) {
        if (!(product && product.ShortcutFilters)) {
            return [];
        }
        const productsMap = this.props.dataMap.products;
        const productChildrenKeys = Object.keys(product.ShortcutFilters).map((key)=>product.ShortcutFilters[`${key}`]);
        const productChildren = this.parseFiltersMapToFilters(productsMap, productChildrenKeys).filter((productChild)=>productChild.Level === product.Level + 1);
        return productChildren.map((productChild)=>this.filterToLink(productChild, this.getProductChildrenItems(productChild), product));
    }
    getProductsFiltersItems() {
        const productsMap = this.props.dataMap.products;
        const products = this.parseFiltersMapToFilters(productsMap).filter((product)=>product.Level === 1);
        const links = products.map((product)=>this.filterToLink(product, this.getProductChildrenItems(product)));
        return this.groupToLink('FilterType_Products', Constants.FilterQuery.product, links);
    }
    createCategoriesLinks(dataValues) {
        return dataValues.map((datavalue)=>this.filterToLink(datavalue, this.getFilterChildrenItems(datavalue)));
    }
    getIndustriesFiltersItems() {
        const industriesMap = this.props.dataMap.industries;
        const industries = this.parseFiltersMapToFilters(industriesMap);
        const links = this.createCategoriesLinks(industries);
        return this.groupToLink('FilterType_Industries', Constants.FilterQuery.industry, links);
    }
    getCloudIndustriesFiltersItems() {
        const { cloudIndustries } = this.props.dataMap;
        const filteredCloudIndustries = this.parseFiltersMapToFilters(cloudIndustries);
        const links = this.createCategoriesLinks(filteredCloudIndustries);
        return this.groupToLink('FilterType_Industries', Constants.FilterQuery.industry, links);
    }
    getCategoriesFiltersItems() {
        const categoryMap = this.getCategoryList();
        const categories = this.parseFilters(Object.entries(categoryMap).map(([categoryKey, categoryValue])=>categoryValue.IsReference ? this.props.dataMap.categories.default[`${categoryKey}`] : categoryValue));
        const links = this.createCategoriesLinks(categories);
        return this.groupToLink('FilterType_Categories', Constants.FilterQuery.category, links);
    }
    getPricingModelsFiltersItems() {
        const pricingModelMap = this.props.dataMap.pricingModel;
        const pricingModels = this.parseFiltersMapToFilters(pricingModelMap);
        const links = pricingModels.map((pricingModel)=>this.filterToLink(pricingModel));
        return this.groupToLink('Global_Loc_pricing_model', Constants.FilterQuery.pricingModel, links);
    }
    getOperatingSystemFiltersItems() {
        const operatingSystemsMap = this.props.dataMap.operatingSystem;
        const operatingSystems = this.parseFiltersMapToFilters(operatingSystemsMap);
        const links = operatingSystems.map((pricingModel)=>this.filterToLink(pricingModel));
        return this.groupToLink('Global_Loc_operating_system', Constants.FilterQuery.operatingSystem, links);
    }
    getPublisherFiltersItems() {
        const publisherMap = this.props.dataMap.publisher;
        const publisher = this.parseFiltersMapToFilters(publisherMap);
        const links = publisher.map((pricingModel)=>this.filterToLink(pricingModel));
        return this.groupToLink('Global_Loc_publisher', Constants.FilterQuery.publisher, links);
    }
    getRatingsFiltersItems() {
        const ratingsMap = this.props.dataMap.ratings;
        const ratings = this.parseFiltersMapToFilters(ratingsMap);
        const links = ratings.map((rating)=>this.filterToLink(rating));
        return this.groupToLink('Global_Loc_ratings', Constants.FilterQuery.ratings, links);
    }
    getAppComplianceFiltersItems() {
        const compianceMap = this.props.dataMap.appCompliance;
        const complianceTypes = this.parseFiltersMapToFilters(compianceMap);
        const links = complianceTypes.map((comlianceType)=>this.filterToLink(comlianceType));
        return this.groupToLink('Global_Loc_app_compliance', Constants.FilterQuery.appCompliance, links, 'Global_Loc_compliance_tooltip');
    }
    getAzureBenefitEligibleItem() {
        const azureBenefitEligibleMap = this.props.dataMap.AzureBenefitEligible;
        const azureBenefitEligibleTypes = this.parseFiltersMapToFilters(azureBenefitEligibleMap);
        const links = (azureBenefitEligibleTypes || []).map((azureBenefitEligibleType)=>this.filterToLink(azureBenefitEligibleType));
        return _object_spread_props(_object_spread({}, links[0]), {
            checkboxTooltip: this.getTooltipContent()
        });
    }
    getServiceTypesFiltersItems() {
        const serviceTypesMap = this.props.dataMap.serviceTypes;
        const serviceTypes = this.parseFiltersMapToFilters(serviceTypesMap);
        const links = serviceTypes.map((serviceType)=>this.filterToLink(serviceType));
        return this.groupToLink('FilterType_ServiceType', Constants.FilterQuery.serviceType, links);
    }
    getCountryFiltersItems() {
        const route = getEntityRegistration(this.props.entityType).route;
        return Object.keys(this.props.countriesList).filter((countryCode)=>!!serviceOffersSupportedCountriesMap[`${countryCode}`]).map((countryCode)=>({
                key: this.getCountryKey(countryCode),
                name: serviceOffersSupportedCountriesMap[`${countryCode}`].name,
                url: this.context.buildHref(route, null, {
                    [Constants.FilterQuery.country]: countryCode,
                    [Constants.FilterQuery.region]: null
                })
            })).sort((a, b)=>sort(a.name, b.name));
    }
    getRegionFiltersItems(regions) {
        const route = getEntityRegistration(this.props.entityType).route;
        return regions.map((region)=>({
                key: this.getRegionKey(region.code),
                name: region.name,
                url: this.context.buildHref(route, null, {
                    [Constants.FilterQuery.country]: this.props.countryCode,
                    [Constants.FilterQuery.region]: region.code
                })
            }));
    }
    getLocationFiltersItems() {
        const links = [
            this.groupToLink(countryGroupName, 'country', this.getCountryFiltersItems())
        ];
        const regions = this.getSelectedCountryRegions();
        if (regions) {
            links.push(this.groupToLink(regionGroupName, 'region', this.getRegionFiltersItems(regions)));
        }
        return this.groupToLink('FilterType_Location', 'location', links);
    }
    getSelectedCountryRegions() {
        let regions;
        const countryCode = this.props.countryCode && this.props.countryCode.toLowerCase();
        if (countryCode === Constants.caCountryCode) {
            return serviceOffersSupportedCAStates;
        } else if (countryCode === Constants.usCountryCode) {
            return serviceOffersSupportedUSStates;
        }
        return regions;
    }
    getFiltersGroups() {
        let links;
        switch(this.props.entityType){
            case Constants.EntityType.Service:
                links = this.getServicesFiltersGroups();
                break;
            case Constants.EntityType.CloudsIndustry:
                links = this.getCloudsIndustryFiltersGroups();
                break;
            case Constants.EntityType.App:
            default:
                links = this.getAppsFiltersGroups();
                break;
        }
        if (this.state.filterSearchValue.length > 0) {
            links = this.searchInFilterLinks(links);
        }
        links = links.filter(({ links = [], checkboxTooltip })=>{
            return (links === null || links === void 0 ? void 0 : links.length) || checkboxTooltip;
        });
        if (this.isSmallScreen()) {
            links = [
                this.groupToLink(rootGroupName, rootGroupName, links)
            ];
        }
        return [
            {
                links
            }
        ];
    }
    getCopilotExtensionsTooltip() {
        return /*#__PURE__*/ _jsx(Stack, {
            role: 'contentinfo',
            children: /*#__PURE__*/ _jsx(Text, {
                variant: "small",
                children: this.context.loc('Global_Loc_Copilot_extension_tooltip', 'Discover apps that work with Microsoft Copilot.Currently only showing Teams apps that work with Copilot, but more to come soon.')
            })
        });
    }
    getCopilotExtensionsItem() {
        const copilotExtensionMap = this.props.dataMap.CopilotExtension;
        const copilotExtensionTypes = this.parseFiltersMapToFilters(copilotExtensionMap);
        const links = (copilotExtensionTypes || []).map((copilotExtensionType)=>this.filterToLink(copilotExtensionType));
        return _object_spread_props(_object_spread({}, links[0]), {
            checkboxTooltip: this.getCopilotExtensionsTooltip()
        });
    }
    getAppsFiltersGroups() {
        const appsFiltersGroup = [
            this.getProductsFiltersItems(),
            this.getCategoriesFiltersItems(),
            this.getIndustriesFiltersItems(),
            this.getPricingModelsFiltersItems(),
            this.getRatingsFiltersItems(),
            this.props.isConverged && this.getOperatingSystemFiltersItems(),
            this.props.isConverged && this.getPublisherFiltersItems(),
            this.getAppComplianceFiltersItems(),
            !isEmptyObject(this.props.dataMap.CopilotExtension) && this.getCopilotExtensionsItem(),
            this.getAzureBenefitEligibleItem()
        ];
        return appsFiltersGroup.filter(Boolean);
    }
    getServicesFiltersGroups() {
        return [
            this.getLocationFiltersItems(),
            this.getProductsFiltersItems(),
            this.getIndustriesFiltersItems(),
            this.getServiceTypesFiltersItems(),
            this.props.isConverged && this.getPricingModelsFiltersItems()
        ];
    }
    getCloudsIndustryFiltersGroups() {
        return [
            this.getLocationFiltersItems(),
            this.getProductsFiltersItems(),
            isOneTaxonomyEnabled() ? this.getCloudIndustriesFiltersItems() : this.getIndustriesFiltersItems(),
            this.getCategoriesFiltersItems(),
            this.getPricingModelsFiltersItems(),
            this.getRatingsFiltersItems()
        ];
    }
    searchInFilterLinks(links) {
        const searchWord = this.state.filterSearchValue;
        const canonicalSearch = (link)=>{
            const isWordFound = link.name && link.name.toLowerCase().indexOf(searchWord.toLowerCase()) >= 0;
            if (!link.links || link.links.length === 0) {
                return isWordFound;
            } else {
                link.links = link.links.filter((subLink)=>canonicalSearch(subLink));
                if (link.links.length > 0) {
                    link.isExpanded = true;
                }
                if (isWordFound || link.links.length > 0) {
                    return true;
                }
            }
        };
        links.forEach((link)=>{
            if (!Array.isArray(link.links)) {
                return;
            }
            link.links = link.links.filter(canonicalSearch);
        });
        return links;
    }
    toggleLinkExpanded(item) {
        this.setState({
            filtersExpandedState: _object_spread_props(_object_spread({}, this.state.filtersExpandedState), {
                [item.key]: !this.state.filtersExpandedState[item.key]
            })
        });
    }
    toggleLinkIfNeeded(item) {
        const filter = this.state.filtersMap[item.key];
        if (!filter) {
            return this.toggleLinkExpanded(item);
        }
        this.setState({
            filtersExpandedState: _object_spread_props(_object_spread({}, this.state.filtersExpandedState), {
                [item.key]: !filter.isActive
            })
        });
    }
    onNavLinkClick(event, item) {
        var _item_url_includes, _item_url, _getNpsModule;
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.FilterClick,
            actionModifier: Constants.Telemetry.ActionModifier.FilterPane,
            details: JSON.stringify({
                key: item.key,
                name: item.name,
                url: item.url,
                filterState: !((_item_url = item.url) === null || _item_url === void 0 ? void 0 : (_item_url_includes = _item_url.includes) === null || _item_url_includes === void 0 ? void 0 : _item_url_includes.call(_item_url, item.key)) ? BusinessTelemetry.Filters.Deactivating : BusinessTelemetry.Filters.Activating
            })
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        pageAction(null, {
            content: {
                contentType: Constants.Telemetry.ContentType.LinkClicked,
                areaName: Constants.Telemetry.AreaName.FilterPane,
                contentName: item.key
            }
        });
        if (event) {
            event.nativeEvent.preventDefault();
        }
        this.toggleLinkIfNeeded(item);
        if (item && item.url) {
            urlPush(item.url);
        }
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter('filterActionsCount');
    }
    onLinkExpandClick(event, item) {
        var _item_url_includes, _item_url;
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.FilterExpand,
            actionModifier: Constants.Telemetry.ActionModifier.FilterPane,
            details: JSON.stringify({
                key: item.key,
                name: item.name,
                url: item.url,
                filterState: !((_item_url = item.url) === null || _item_url === void 0 ? void 0 : (_item_url_includes = _item_url.includes) === null || _item_url_includes === void 0 ? void 0 : _item_url_includes.call(_item_url, item.key)) ? BusinessTelemetry.Filters.Deactivating : BusinessTelemetry.Filters.Activating
            })
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        pageAction(null, {
            content: {
                contentType: Constants.Telemetry.ContentType.LinkExpanded,
                areaName: Constants.Telemetry.AreaName.FilterPane,
                contentName: item.key
            }
        });
        this.toggleLinkExpanded(item);
    }
    getResetFilter() {
        const { activeFilters, entityType } = this.props;
        if (!(activeFilters && activeFilters.length)) {
            return null;
        }
        const redirectHref = getResetFiltersHref(this.context, entityType);
        return /*#__PURE__*/ _jsx(InternalLink, {
            href: redirectHref,
            className: "c-hyperlink resetButton",
            role: "button",
            telemetryDetails: BusinessTelemetry.Filters.FiltersCleared,
            accEnabled: true,
            children: this.context.loc('Gallery_FilterPane_ClearButton', 'Clear all')
        });
    }
    filterSearchChange(filterSearchValue) {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.FilterSearchChange,
            actionModifier: Constants.Telemetry.ActionModifier.FilterPane,
            details: JSON.stringify({
                filterSearchValue
            })
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        this.setState({
            filterSearchValue: filterSearchValue && filterSearchValue.toLowerCase()
        });
    }
    getActiveChildrenCount(link) {
        if (!link.links) {
            return 0;
        }
        return link.links.reduce((activesCount, currentSubLink)=>{
            const subFilter = this.state.filtersMap[currentSubLink.key];
            const isSubActive = subFilter && subFilter.isActive;
            return activesCount + (isSubActive ? 1 : 0);
        }, 0);
    }
    isSmallScreen() {
        var _this_state_windowSize;
        return ((_this_state_windowSize = this.state.windowSize) === null || _this_state_windowSize === void 0 ? void 0 : _this_state_windowSize.width) <= ScreenWidthMinXLarge;
    }
    renderLink(props) {
        const { link } = props;
        const isGroup = !link.url;
        const activeChildren = this.getActiveChildrenCount(link);
        let isChild = false;
        let isActive = false;
        let isRoot = false;
        let localizedName = '';
        let tooltip = '';
        if (isGroup) {
            isActive = activeChildren > 0;
            if (link.tooltip) {
                tooltip = link.tooltip;
            }
        } else {
            const filter = this.state.filtersMap[link.key];
            if (filter) {
                isChild = filter.isChild;
                isActive = filter.isActive;
                localizedName = filter.localizedName;
                tooltip = filter.tooltip;
            }
        }
        let clearAll = null;
        if (link.key === rootGroupName) {
            isRoot = true;
            clearAll = this.getResetFilter();
        }
        return /*#__PURE__*/ _jsx(FilterLink, _object_spread_props(_object_spread({
            locKey: link.name,
            localizedName: localizedName,
            isRoot: isRoot,
            isGroup: isGroup,
            isChild: isChild,
            isActive: isActive,
            activeChildren: activeChildren,
            searchValue: this.state.filterSearchValue,
            tooltip: tooltip,
            checkboxTooltip: link.checkboxTooltip
        }, props), {
            children: clearAll
        }));
    }
    getTooltipContent() {
        return /*#__PURE__*/ _jsxs(Stack, {
            role: 'contentinfo',
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    variant: "small",
                    children: this.context.loc('Global_Loc_Azure_benefit_tooltip', 'Purchasing these offers through the marketplace benefits your organization by reducing your existing Azure commitment.')
                }),
                /*#__PURE__*/ _jsx(ExternalLink, {
                    className: "c-hyperlink",
                    target: "_blank",
                    href: Constants.AzureBenefitURL,
                    accessibilityEnabled: true,
                    children: this.context.loc('Global_Loc_Azure_benefit_tooltip_link', 'Learn more about your benefits')
                })
            ]
        });
    }
    renderImpl() {
        const { filterSearchValue } = this.state;
        const filterGroups = this.getFiltersGroups();
        const filterGroupLinksLength = filterGroups[0].links.length;
        const { dataMap, isEmbedded, countryCode, countriesList, currentView, query, params, regionCode, entityType, getFilterLink, embedHost, stateCountryFilterHandler } = this.props;
        if (isEmbedded) {
            return /*#__PURE__*/ _jsx(SharedFilterPane, {
                dataMap: dataMap,
                getFilterLink: getFilterLink,
                embedHost: embedHost,
                isEmbedded: isEmbedded,
                entityType: entityType,
                stateCountryFilterHandler: stateCountryFilterHandler,
                countryCode: countryCode,
                regionCode: regionCode,
                params: params,
                query: query,
                currentView: currentView,
                countriesList: countriesList
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "filterPaneContainer",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "filterPane",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "filterPaneHeader",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "filterPaneTitle",
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        variant: "large",
                                        className: "galleryTitle",
                                        children: this.context.loc('Gallery_FilterPane_MainTitle', 'Filters')
                                    }),
                                    this.getResetFilter()
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "filterPaneSearch",
                                children: /*#__PURE__*/ _jsx(SearchBox, {
                                    "data-bi-id": Constants.Telemetry.Action.FilterSearchChange,
                                    "data-bi-value": filterSearchValue,
                                    styles: this.searchStyles,
                                    placeholder: this.context.loc('FilterType_Placeholder', 'Search filters'),
                                    underlined: true,
                                    onChange: (_, newValue)=>this.filterSearchChange(newValue),
                                    ariaLabel: filterSearchValue
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                role: "status",
                                "aria-label": this.context.locParams('Filter_Pane_Search_Results_Aria_Label', [
                                    `${filterGroupLinksLength}`
                                ], `${filterGroupLinksLength} Results found`)
                            }),
                            /*#__PURE__*/ _jsx(Nav, {
                                groups: filterGroups,
                                styles: this.navStyles,
                                linkAs: (props)=>this.renderLink(props),
                                onLinkClick: (event, item)=>this.onNavLinkClick(event, item),
                                onLinkExpandClick: (event, item)=>this.onLinkExpandClick(event, item),
                                selectedKey: ""
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "navStyles", void 0), _define_property(this, "searchStyles", void 0), _define_property(this, "updateWindowDimensions", ()=>{
            var _getWindow;
            this.setState({
                windowSize: {
                    width: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.innerWidth
                }
            });
        });
        const filtersMap = this.getFiltersMap();
        this.state = {
            filterSearchValue: '',
            filtersMap,
            filtersExpandedState: this.computeFilterExpandedState(filtersMap),
            windowSize: {},
            hasInit: false
        };
        this.navStyles = {
            root: {
                overflow: 'hidden',
                width: 'auto'
            },
            groupContent: {
                '&': {
                    marginBottom: 0,
                    opacity: '1 !important',
                    visibility: 'visible !important',
                    transform: 'unset !important'
                }
            },
            navItems: {
                [`[name='${countryGroupName}'] + &, [name='${regionGroupName}'] + &`]: {
                    maxHeight: 150,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }
            },
            link: {
                '&': {
                    backgroundColor: 'transparent'
                },
                [`[name='${rootGroupName}'] &`]: {
                    fontSize: 18,
                    padding: '0 0 0 16px'
                }
            },
            chevronButton: {
                '&': {
                    backgroundColor: 'transparent'
                },
                [`[name='${rootGroupName}'] &`]: {
                    left: 'auto',
                    right: 16
                }
            },
            chevronIcon: {
                color: 'rgb(50, 49, 48)'
            }
        };
        this.searchStyles = {
            root: {
                backgroundColor: 'transparent'
            }
        };
    }
}
FilterPane.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func,
    buildHref: PropTypes.func
};
